import { j as u } from "../../jsx-runtime-CZlWR0BA.js";
import { C as f, H as g } from "../../styled-components.browser.esm-CdvvWRMU.js";
const e = {
  mobileS: "320px",
  mobileM: "375px",
  mobileL: "425px",
  tablet: "768px",
  laptop: "1024px",
  laptopL: "1440px",
  desktop: "2560px"
}, p = {
  mobileS: `(min-width: ${e.mobileS})`,
  mobileM: `(min-width: ${e.mobileM})`,
  mobileL: `(min-width: ${e.mobileL})`,
  tablet: `(min-width: ${e.tablet})`,
  laptop: `(min-width: ${e.laptop})`,
  laptopL: `(min-width: ${e.laptopL})`,
  desktop: `(min-width: ${e.desktop})`,
  desktopL: `(min-width: ${e.desktop})`
}, $ = (t) => f`
  overflow: hidden;
  text-overflow: ellipsis;
  ${typeof t != "boolean" && t.wrap ? "" : "white-space: nowrap;"}
`, x = (t) => f`
  display: -webkit-box;
  -webkit-line-clamp: ${t};
  -webkit-box-orient: vertical;
  overflow: hidden;
`, S = ({
  mt: t,
  mb: r,
  ml: o,
  mr: i
}) => f`
  ${t !== void 0 ? `margin-top: ${t};` : ""}
  ${i !== void 0 ? `margin-right: ${i};` : ""}
  ${r !== void 0 ? `margin-bottom: ${r};` : ""}
  ${o !== void 0 ? `margin-left: ${o};` : ""}
`, l = (t, r, o = !1) => {
  switch (r) {
    case "xs":
      return o ? t.fontSizeQuarck : t.fontSizeNano;
    case "sm":
      return o ? t.fontSizeNano : t.fontSizeXxxs;
    case "md":
      return o ? t.fontSizeXxxs : t.fontSizeXxs;
    case "lg":
      return o ? t.fontSizeXxs : t.fontSizeXs;
    case "xl":
      return o ? t.fontSizeXs : t.fontSizeSm;
    case "2xl":
      return o ? t.fontSizeSm : t.fontSizeMd;
    case "3xl":
      return o ? t.fontSizeMd : t.fontSizeLg;
    case "4xl":
      return o ? t.fontSizeLg : t.fontSizeXl;
    case "5xl":
      return o ? t.fontSizeXl : t.fontSizeXxl;
    default:
      return r;
  }
}, b = (t, r) => {
  switch (r) {
    case "light":
      return t.fontWeightLight;
    case "regular":
      return t.fontWeightRegular;
    case "semibold":
      return t.fontWeightSemibold;
    case "bold":
      return t.fontWeightBold;
    default:
      throw new Error("Invalid font weight");
  }
}, w = (t, r) => {
  switch (r) {
    case "light":
      return t.fontFamilyLight;
    case "regular":
      return t.fontFamilyRegular;
    case "semibold":
      return t.fontFamilySemibold;
    case "bold":
      return t.fontFamilyBold;
    default:
      throw new Error("Invalid font weight");
  }
}, y = (t, r) => {
  switch (r) {
    case "tight":
      return t.lineHeightTight;
    case "fair":
      return t.lineHeightFair;
    case "confy":
      return t.lineHeightConfy;
    default:
      throw new Error("Invalid line height");
  }
}, z = (t, r, o) => {
  switch (r) {
    case "primary":
      return t.brandPrimaryMedium;
    case "secondary":
      return t.brandHighlightMedium;
    case "success":
      return t.colorSupportPositiveMedium;
    case "error":
      return t.colorSupportNegativeMedium;
    case "warning":
      return t.colorSupportWarningDark;
    case "textPrimary":
      return o ?? t.colorNeutralDarkest;
    case "textSecondary":
      return t.colorNeutralDark;
    case "textDisabled":
      return t.colorNeutralMedium;
    default:
      return r;
  }
}, m = g.h1`
  color: ${({ theme: t, color: r }) => z(t, r, t.colorSupportTextDarkest)};
  @media ${p.tablet} {
    font-size: ${({ size: t, theme: r }) => l(r, t)};
  }
  font-size: ${({ size: t, theme: r, isResponsive: o }) => l(r, t, o)};
  font-weight: ${({ theme: t, weight: r }) => b(t, r)};
  font-family: ${({ theme: t, weight: r, fontFamily: o }) => o ?? w(t, r)};
  line-height: ${({ theme: t, lineHeight: r }) => y(t, r)};
  ${S};
  padding: 0;

  ${({ truncate: t }) => t && $(t)};
  ${({ lineClamp: t }) => t && x(t)};
`, F = ({
  as: t = "h1",
  size: r = "lg",
  weight: o = "bold",
  lineHeight: i = "fair",
  isResponsive: n = !1,
  truncate: a = !1,
  color: s = "textPrimary",
  children: c,
  ...d
}) => /* @__PURE__ */ u.jsx(
  m,
  {
    as: t,
    size: r,
    weight: o,
    lineHeight: i,
    truncate: a,
    isResponsive: n,
    color: s,
    ...d,
    children: c
  }
), h = g.p`
  color: ${({ theme: t, color: r }) => z(t, r)};
  @media ${p.tablet} {
    font-size: ${({ size: t, theme: r }) => l(r, t)};
  }
  font-size: ${({ size: t, theme: r, isResponsive: o }) => l(r, t, o)};
  font-weight: ${({ theme: t, weight: r }) => b(t, r)};
  font-family: ${({ theme: t, weight: r, fontfamily: o }) => o ?? w(t, r)};
  line-height: ${({ theme: t, lineHeight: r }) => y(t, r)};

  ${({ mt: t, mb: r, ml: o, mr: i, as: n }) => S({ mt: t, mb: r ?? (n === "p" ? "0.625rem" : void 0), ml: o, mr: i })};

  padding: 0;

  ${({ truncate: t }) => t && $(t)};
  ${({ lineClamp: t }) => t && x(t)};
`, k = ({
  children: t,
  as: r = "p",
  size: o = "xs",
  weight: i = "regular",
  lineHeight: n = "confy",
  truncate: a = !1,
  isResponsive: s = !1,
  color: c = "textPrimary",
  ...d
}) => /* @__PURE__ */ u.jsx(
  h,
  {
    as: r,
    size: o,
    weight: i,
    lineHeight: n,
    truncate: a,
    isResponsive: s,
    color: c,
    ...d,
    children: t
  }
), H = k;
export {
  F as Heading,
  H as Text
};
